import type { FaireProductEntity } from "../../entity_types/product";

export const p_bl5t0i30: FaireProductEntity = {
  token: "p_bl5t0i30",
  type: "product",
  name: "So Hot Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/345ae06e4c461f4705140c1e5a8b5596ecff4970b317642ba6805ac50cde3b4d/1528360412.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/e738a9b939466bfcb5857db7a19c795542695535e5bca71481ccb5df7095b6bc/1528360412.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:26.065Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
